const normalizeUserAgent = (navigatorLike) =>
  String(navigatorLike?.userAgent || "");

const getDefaultNavigator = () =>
  typeof navigator === "undefined" ? undefined : navigator;

const getDefaultDocument = () =>
  typeof document === "undefined" ? undefined : document;

export const getViewerBrowser = (navigatorLike = getDefaultNavigator()) => {
  const userAgent = normalizeUserAgent(navigatorLike);

  if (/Firefox\//i.test(userAgent)) {
    return "firefox";
  }

  if (/Edg\//i.test(userAgent)) {
    return "edge";
  }

  if (/Chrome\//i.test(userAgent) || /CriOS\//i.test(userAgent)) {
    return "chrome";
  }

  if (/Safari\//i.test(userAgent)) {
    return "safari";
  }

  return "unknown";
};

export const getViewerOperatingSystem = (
  navigatorLike = getDefaultNavigator(),
) => {
  const userAgent = normalizeUserAgent(navigatorLike);
  const platform = String(navigatorLike?.userAgentData?.platform || navigatorLike?.platform || "");

  if (/Win/i.test(platform) || /Windows/i.test(userAgent)) {
    return "windows";
  }

  if (/Mac/i.test(platform) || /Mac OS X/i.test(userAgent)) {
    return "mac";
  }

  if (/Android/i.test(platform) || /Android/i.test(userAgent)) {
    return "android";
  }

  if (/iPhone|iPad|iPod/i.test(platform) || /iPhone|iPad|iPod/i.test(userAgent)) {
    return "ios";
  }

  if (/Linux/i.test(platform) || /Linux/i.test(userAgent)) {
    return "linux";
  }

  return "unknown";
};

export const applyViewerPlatformAttributes = ({
  documentLike = getDefaultDocument(),
  navigatorLike = getDefaultNavigator(),
} = {}) => {
  const root = documentLike?.documentElement;
  if (!root) {
    return;
  }

  root.dataset.viewerBrowser = getViewerBrowser(navigatorLike);
  root.dataset.viewerOs = getViewerOperatingSystem(navigatorLike);
};
